import { create } from 'zustand'

import { PERSONAL_CENTER_SECTION_KEYS, type PersonalCenterSectionKey } from '@/views/Personalcenter/constants/sections'

interface PersonalcenterStore {
  isInformation: PersonalCenterSectionKey
  setIsInformation: (isInformationName: PersonalCenterSectionKey) => void
}

export const usePersonalcenterStore = create<PersonalcenterStore>((set) => ({
  isInformation: PERSONAL_CENTER_SECTION_KEYS.PROFILE,
  setIsInformation: (title) => set(() => ({ isInformation: title })),
}))
